import { mergeStyles, getTheme } from '@fluentui/react';

const palette = getTheme().palette;
export const mediaControlStyles = mergeStyles({
    height: '3.75rem',
    padding: '0 0.8125rem',
    display: 'inline-block',
    borderRadius: 7,
    overflow: 'hidden'
});

export const controlButtonStyle = mergeStyles({
    backgroundColor: palette.white,
    width: '2rem',
    height: '3.75rem',
    border: '0.125rem',
    borderRadius: 2,
    marginRight: '0.2375rem',
    color: 'rgb(255,50,0)',

    selectors: {
        ':hover': {
            color: 'rgb(255,50,0)', backgroundColor: palette.neutralLighter
        }
    }
});

export const container = mergeStyles({
    position: 'relative'
});

export const containerimg = mergeStyles({
    display: 'block'
});

export const containericon = mergeStyles({
    position: 'absolute',
    left: 0,
    bottom:1
});

export const containerControlButtonStyle = mergeStyles({
    width: '2rem',
    border: '0.125rem',
    borderRadius: 2,
    maxHeight: '20px',
    //marginRight: '0.2375rem',
    color: 'rgb(255,50,0)',
    selectors: {
        ':hover': {
            color: 'rgb(255,50,0)',
            backgroundColor: palette.neutralLighter
        }
    }
});
export const containerControlButtonDisabledStyle = mergeStyles(containerControlButtonStyle, {
    selectors: {
        ':hover': { backgroundColor: palette.neutralLighter }
    },
});


export const displayNoneStyle = mergeStyles({
    display: 'none'
});

export const hiddenStyle = mergeStyles({
    visibility: 'hidden'
});

export const controlButtonDisabledStyle = mergeStyles(controlButtonStyle, {
    selectors: {
        ':hover': { backgroundColor: palette.neutralLighterAlt }
    },
});

export const endCallButtonStyle = mergeStyles({
    backgroundColor: 'rgb(255,50,0)',
    width: '6.5625rem',
    height: '2.1875rem',
    border: '0.125rem',
    marginRight: '0.75rem',
    marginLeft: '0.75rem',
    borderRadius: 2,
    color: palette.white,
    selectors: {
        ':focus': { color: palette.white },
        ':hover': { color: palette.white },
        ':active': { color: palette.white }
    }
});
export const endCallButtonTextStyle = mergeStyles({
    color: palette.white,
    padding: '0.3125rem',
    fontSize: '0.875rem',
    lineHeight: '3.75rem'
});
export const fullWidth = mergeStyles({
    width: '100%'
});